import React, { Component } from 'react';
import { getComponents } from '@/utils/constant';
import componentsInfo from '@/config/couponConfig.json';
import baseInfo from '@/config/base-config.json';
import { setTitle, setRightButton } from '@/components/CrgtEvent';
import _ from 'lodash';
import loading from "@/utils/loading"
import { trackPV,parseUrlQuery } from '@/utils/util';

class Index extends Component {
  constructor(props) {
    super(props);
    const config = (typeof window !== 'undefined') ?
      (window.INIT_DATA || props.initState || componentsInfo) : (props.initState);
    const baseConfig = (typeof window !== 'undefined') ?
      (window.BASE_DATA || props.initBase || baseInfo) : (props.initBase);
    this.state = {
      config: config,
      baseConfig: baseConfig,
      pageIndex: baseConfig.props.pageIndex,
      params: {}
    }
  }

  handleChangePage = (path, data = {}) => {
    const { pageIndex } = this.state;
    if (pageIndex === path) return;
    if (!_.isEmpty(data)) {
      const { params } = this.state;
      this.setState({ params: { ...params, ...data } })
    };
    this.setState({ pageIndex: `${path}` })
  }

  scrollToElement = (id) => {
    if (!id) return;
    const curEditElement = document.getElementById(id);
    if (!curEditElement) return
    const scrollHeight = this.getElementTop(curEditElement)
    window.scrollTo(0, scrollHeight)
  }

  getElementTop(el) {

    var actualTop = el.offsetTop
    var current = el.offsetParent

    while (current !== null) {
      actualTop += current.offsetTop
      current = current.offsetParent

    }
    return actualTop

  }
  componentDidMount() {
    setTimeout(() => {
      loading.hide()
    }, 500);
    trackPV('p_open_common_3');
    this.initPage()

    window.onload = () => {
      this.scrollToElement()

    }

    this.getCurParamsQuery()
  
  }

  initPage() {
    const { color, isShare, shareTitle, desc, link, imgUrl, externalLink, activityKey } = this.state.baseConfig.props;
    const title = _.get(this.state.config, `${this.state.pageIndex}.title`)
    const {isWX} = window.crgt;
    window._externalLink = externalLink
    window._activityKey = activityKey
    setTitle({ title: _.isEmpty(title) ? this.state.baseConfig.props.title : title, color });
    const shareInfo = { title: shareTitle, desc, link, imgUrl }

    const {
      modalBgImg, modalCouponBg, modalCouponColor,modalCouponTitle, 
      modalCouponTitleColor, modalDescColor, modalNoteColor, modalButtonColor,modalButtonBg} = this.state.baseConfig.props;
    const modalInfo = {
      modalBgImg, modalCouponBg, modalCouponColor,modalCouponTitle, 
      modalCouponTitleColor, modalDescColor, modalNoteColor, modalButtonColor,modalButtonBg};
    if (isShare === '1') {
      setRightButton(shareInfo);
    }
    if (isWX) {
      window.crgt.share.setShareInfo(shareInfo)
    }
    this.setState({ params: {shareInfo: shareInfo, modalInfo: modalInfo} })
  }

  getCurParamsQuery() {
    const query = parseUrlQuery()
    const { id, pageIndex } = query;
    if (!_.isEmpty(pageIndex)) {
      this.handleChangePage(pageIndex)
    }
    if (!_.isEmpty(id)) {
      this.scrollToElement(id)
    }
  }

  render() {
    const { props: { backgroundColor = "#f5f5f9" } } = this.state.baseConfig;
    const { pageIndex, params } = this.state;
    const Components = getComponents(_.get(this.state.config, `${pageIndex}.data`), this.handleChangePage, params)
    return <div style={{ "backgroundColor": backgroundColor }}>{Components}</div>
  }
}

export default Index
